module.exports = __webpack_public_path__ + "img/jicheng (5).9d2cddae.png";